// AutographFormFields.jsx
import React from 'react';
import { Field } from 'react-final-form';
import { ShippingAddressFormFields } from '../../../../components';
import css from './AutographFormFields.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import ShippingAddressOptionsField from '../ShippingAddressOptionsField';
import PriceInputField from '../PriceInputField';
import TitleInputField from '../TitleInputField';
import DateNeededInputField from '../DateNeededInputField';
import PersonalizationFormField from '../PersonalizationFormField';
import { PHOTO } from '../../../../util/constants';
import SelectedPhotosField from './SelectedPhotosField';

const AutographFormFields = ({ photoOptions = [], formId, values }) => {
  const { title } = values || {};
  const intl = useIntl();
  const { formatMessage } = intl;
  return (
    <div className={css.autographSection}>
      {/* Photo Autograph Offering */}
      <div className={css.offeringBlock}>
        <div className={css.offeringHeader}>
          <h4>
            <FormattedMessage id="AutographFormFields.photoAutograph" />
          </h4>
        </div>{' '}
        {/* Photo Selection - Multiple Checkboxes with Image Preview */}
        {title === PHOTO && <SelectedPhotosField photoOptions={photoOptions} />}
        <div className={css.formRow}>
          <div className={css.formFld}>
            {/* Title input field */}
            <TitleInputField label="Title" id="title" fieldName="title" />
          </div>{' '}
          <div className={css.formFld}>
            {/* Price input field */}
            <PriceInputField formId={formId} />
          </div>
        </div>
        {/* Date Needed By Date */}
        <DateNeededInputField
          label={formatMessage({
            id: 'AutographFormFields.DateNeededInputField.dateNeededByLabel',
          })}
          fieldName={'dateNeededBy'}
        />
        <div className={css.radiosSection}>
          {/* Shipping Address Choice */}
          <ShippingAddressOptionsField />
          {/* Custom Address - conditional */}
          <Field name="addressType">
            {({ input }) => input.value === 'custom' && <ShippingAddressFormFields />}
          </Field>
        </div>
        {/* Personalization */}
        <PersonalizationFormField
          label={formatMessage({
            id: 'AutographFormFields.PersonalizationFormField.label',
          })}
          placeholder={formatMessage({
            id: 'AutographFormFields.PersonalizationFormField.placeholder',
          })}
          fieldName={'personalization'}
          rows={4}
        />
      </div>
    </div>
  );
};

export default AutographFormFields;
